import { ProgressValues } from '@pc/progress-step-indicator';
import { CheckoutSteps } from './checkout-steps';

export const checkoutStepProgressMap = {
  [CheckoutSteps.DeliveryAddress]: ProgressValues.Ten,
  [CheckoutSteps.SecureCheckout]: ProgressValues.Fifty
};

export const checkoutFragmentsProgressMap = {
  [CheckoutSteps.DeliveryAddress]: 'delivery',
  [CheckoutSteps.SecureCheckout]: 'checkout'
};
